import {get} from "lodash"
import BaseService from "./Base"
import {CollegesCreatePayload, DeleteCollegesPayload, EditCollegesPayload, ListCollegesPayload} from "types/colleges"

class CollegesService extends BaseService {
    constructor() {
        super(process.env.REACT_APP_COLLEGE_API_BASE_URL)
    }

    getAllColleges = async (params: ListCollegesPayload) => {
        const response = await this.post("/v3/colleges/list", params)
        return get(response, "data", [])
    }
}

export default CollegesService
